import Headroom from 'headroom.js'
import Rellax from 'rellax'
import 'slick-carousel'
import 'jquery.marquee'

//Header functionality and mobile menu
const initHeader = () => {
  const headroom = new Headroom(document.querySelector('header'), {
    tolerance: 10,
  })
  headroom.init()
  $(document).on('click', '[data-toggle-nav]', () => {
    $('.menu-btn').toggleClass('active')
    $('.mobile').toggleClass('nav-active')
    $('body').toggleClass('no-scroll')
  })
}

/**
 * Drop Down Ordering section Functionality
 */
const pusherDown = () => {
  $(document).on('click', '[data-toggle-top]', () => {
    $('.header-main, .header-top, .banner').toggleClass('slide-up')
  })
}

/** 
 * Add parallax functionality to decorations
 * @param {string} selector
 */
const initRellax = (selector) => {
  let decoration = document.querySelector(selector)
  if (decoration) {
    new Rellax(selector)
  }
}

//Slider Functionality
const initSlider = () => {
  $('.slider').slick({
    autoplay: true,
    arrows:false,
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })
}

const initTimeline = () => {
  var activeIndex = $('.active-tab').index(),
      $contentlis = $('.tabs-content .year-item'),
      $tabslis = $('.tabs .year');

  // Show content of active tab on loads
  $contentlis.eq(activeIndex).show();

  $('.tabs').on('click', '.year', function (e) {
    var $current = $(e.currentTarget),
        index = $current.index();
    
    $tabslis.removeClass('active-tab');
    $current.addClass('active-tab');
    $contentlis.hide().eq(index).show();
   });
}

//Highlight left nav item when in corresponding section in Service Block
// $(window).scroll(function() {
//     var position = $(this).scrollTop();

//     $('.year-item').each(function() {
//       var target = $(this).offset().top;
//       var id = $(this).attr('id');

//       if (position + 200 >= target) {
//         $('#timeline > a').removeClass('active');
//         $('#timeline > a[href=#' + id + ']').addClass('active');
//       }

//     });
// });

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    initHeader()
    pusherDown()
    initRellax('.parallax')
    initSlider()
    initTimeline()
    $('.marquee').each(function(){
      $(this).marquee({
        'startVisible' : true,
        'allowCss3Support' : true,
        'speed' : 50,
        'gap' : 20,
        'pauseOnHover' : true,
      })
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js